import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';

import styles from './ServiceTypeInstructionsBanner.module.scss';
import { TextField } from './TextField';
import { ServiceType } from 'hooks/context/serviceType/models';
import { Banner, BannerVariant } from './Banner';
import { NOTE_TEST_ID, SERVICE_TYPE_NOTE } from 'components/ContactInfoForm.const';
import { Icon } from './Icon';
import { useContactInfoFormState } from 'components/ContactInfoForm';
import { useServiceType } from 'hooks/context/serviceType';

export const ServiceTypeInstructionsBanner: React.FC = () => {
  const { t } = useTranslation();

  const { updateTypeMetadata } = useServiceType();

  const { currentServiceType, note: curbsideInstructions } = useServiceType();

  const {
    serviceTypeNote,
  } = useContactInfoFormState();

  const onServiceTypeNoteChange: React.ChangeEventHandler<HTMLInputElement> = useCallback(e => {
    e.persist();
    updateTypeMetadata(existingValue => {
      if (existingValue.note === e.target.value) return existingValue;

      return ({ ...existingValue, note: e.target.value });
    });
  }, [updateTypeMetadata]);

  return (
    <>
    {currentServiceType === ServiceType.CURBSIDE && curbsideInstructions && (
      <Banner variant={BannerVariant.INFO} className={styles.curbsideNote} rounded={true} data-testid={NOTE_TEST_ID}>
        <div className={styles.icon}><Icon aria-hidden={true} name={'curbside'} size={36} /></div>
        <div className={styles.noteWrapper}>
          <p className={styles.bold}>{t('contactForm.curbside_note')}</p>
          <p>{curbsideInstructions}</p>
        </div>
      </Banner>
    )}

    {currentServiceType === ServiceType.CURBSIDE && (
      <TextField
        className={styles.inputField}
        errorMessage={t('contactForm.emptyField')}
        label={t('contactForm.vehicle_description')}
        labelClass={styles.label}
        onChange={onServiceTypeNoteChange}
        required={true}
        name="serviceTypeNote"
        value={serviceTypeNote}
        data-testid={SERVICE_TYPE_NOTE}
      />
    )}
    </>
  );
};
